export const httpUrl = import.meta.env.VITE_OC_API_HTTP_URL
export const apiKey = import.meta.env.VITE_OC_API_KEY
